import { RouterLink } from '../../generic/Link';
import Flex from '../../generic/Flex';
import Icon, { IconClassName } from '../../generic/Icon';

type SummaryActionOptionProps = {
  to: string;
  action: string;
  icon: IconClassName;
  iconHasSpin?: boolean;
  openInNewTab?: boolean;
  className?: string;
};

/**
 * Component for rendering an nav action option found in a project summary page's Actions panel.
 * This component does not handle actions other than router navigation.
 *
 * @param {string} to - Where the user should be redirected to upon clicking the action button.
 * @param {string} action - The button label.
 * @param {IconClassName} icon - The icon to display.
 * @param {boolean} [iconHasSpin] - If the icon should rotate.
 * @param {boolean} [openInNewTab] - If the action button should open a new tab upon click.
 * @param {string} [className] - CSS styling for the action button.
 */
const SummaryActionOption = ({
  to,
  action,
  icon,
  iconHasSpin,
  openInNewTab = false,
  className = '',
}: SummaryActionOptionProps) =>
  <RouterLink
    to={to}
    openInNewTab={openInNewTab}
    className={className}
  >
    <Flex justify="flex-start">
      <Icon
        icon={icon}
        hasSpin={iconHasSpin}
      />
      <div className="margin-left-md">{action}</div>
    </Flex>
  </RouterLink>;

export default SummaryActionOption;
